import React, { useState, useEffect } from "react";
import { Form, Input, Button, Row, Col, message, notification } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import { setNewPassword } from "../../api"; // API call for setting password
import WebsiteLogo from "../../components/RegistrationLeftBar/WebsiteLogo";
import RegistrationLeftBar from "../../components/RegistrationLeftBar";
import { useSelector } from "react-redux";

const SetNewPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [form] = Form.useForm();
  const token = searchParams.get("token"); // Extract token from URL
  const [loading, setLoading] = useState(false)

    const authDetails = useSelector((state) => state.auth);
    const { current } = authDetails;

  useEffect(() => {
    if (!token) {
    notification.error({message: "Password Reset Token is missing"});
      navigate("/login"); // Redirect to login if token is missing
    }
  }, [token, navigate]);

  const handleSubmit = (values) => {
    setLoading(true)
    setNewPassword({ token, newPassword: values.password })
      .then((res) => {
        notification.success({ message: "Password set successfuly, continue login!" });
        setLoading(false)
        navigate("/login");
      })
      .catch((error) => {
        notification.error({ message: error?.response?.data?.message || "Failed to submit form!" });
        setLoading(false)
      });
  };



  return (
    <Row className="align-content mobile-media">
      <Col md={12} xs={24} xl={12} sm={24} className="leftbar-background">
        {/* You can add a Logo or Sidebar here */}
        <WebsiteLogo />
        <RegistrationLeftBar current={current} />

      </Col>
      <Col md={12} xs={24} xl={12} sm={24}>
        <div className="auth-page">
          <Col span={16} offset={4} className="rm-offset">
            <h1 className="create-account">Create new password</h1>
            <p className="option-text">
              "Type and confirm a secure new password for your account."
            </p>
            <Form form={form} onFinish={handleSubmit}>
              <Form.Item
                name="password"
                hasFeedback
                label={<span className="label-input">New Password</span>}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                rules={[
                  { required: true, message: "Please enter your new password." },
                  { min: 6, message: "Password must be at least 6 characters long." },
                ]}
              >
                <Input.Password
                  className="input-style input-font-style"
                  placeholder="•••••••••"
                  size="large"
                />
              </Form.Item>
              <Form.Item
                name="confirmPassword"
                hasFeedback
                label={<span className="label-input">Repeat New Password</span>}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                dependencies={["password"]}
                rules={[
                  { required: true, message: "Please confirm your password!" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error("Passwords do not match!"));
                    },
                  }),
                ]}
              >
                <Input.Password
                  className="input-style input-font-style"
                  placeholder="•••••••••"
                  size="large"
                />
              </Form.Item>
              <Form.Item>
                <Button
                  className="form-submit-btn"
                  type="primary"
                  htmlType="submit"
                  shape="round"
                  size="large"
                  loading={loading}
                >
                  Reset password
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </div>
      </Col>
    </Row>
  );
};

export default SetNewPassword;
